// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c70e422b","453":"3666cd53","455":"314cd6bf","977":"3ebbb139"}[chunkId] + ".chunk.js";
};